import { Router } from '@angular/router';
import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-selia-modal',
  templateUrl: './selia-modal.component.html',
  styleUrl: './selia-modal.component.scss'
})
export class SeliaModalComponent {
  @ViewChild('modalSeleccionElemento')
  modalSeleccionElemento!: ElementRef;

  constructor(private router: Router) {}
  
  onSubmitSeleccionarElemento() {
    this.abrirCerrarModal();
    this.router.navigate(['/justino/bot']);
  }

  abrirCerrarModal() {
    this.modalSeleccionElemento.nativeElement.click();
  }
}